







import {
  apiV1AdminRecommendPath,
} from '@/rails/routes'
import axios from 'axios'
import PageBase, {BreadCrumb} from '@/pages/page-base'
import Recommend, {IRecommend} from '@/models/Recommend'
import {Component} from 'vue-property-decorator'
import RecommendForm from '@/components/admin/recommends/Form.vue'

@Component({
  components: {
    RecommendForm
  }
})
export default class RecommendEdit extends PageBase {
  recommend: Recommend = new Recommend()

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'おすすめ求人一覧',
        to: '/admin/recommends',
        exact: true
      },
      {
        text: 'おすすめ求人編集'
      }
    ]
  }

  async mounted(): Promise<void> {
    try {
      super.mounted()
      const recommend = await axios.get<IRecommend>(apiV1AdminRecommendPath(this.$route.params.id))
      this.recommend = new Recommend(recommend.data)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async save(): Promise<void> {
    try {
      if(!this.recommend.name) {
        this.showError('タイトルを入力してください')
        return
      }
      if (this.recommend.active == null) {
        this.showError('表示ステータスを入力してください')
        return
      }
      if (!this.recommend.medium) {
        this.showError('画像を選択してください')
        return
      }
      this.showLoading()
      await axios.put(apiV1AdminRecommendPath(this.$route.params.id), {
        recommend: this.recommend.toParams()
      })
      this.hideLoading()
      await this.$router.push('/admin/recommends')
      this.showMessage('変更を保存しました。')
    } catch(e) {
      console.error(e)
    }
  }
}
